import axios from 'axios';
import qs from 'qs';
import { pathOr } from 'ramda';

const endPoint = 'https://api.kollecta.io';
//const endPoint = 'http://localhost:3003'; // local server address (kollecta-core)
const baseURL = `${endPoint}/api`;
const timeout = 2147483647;
const axiosInstance = axios.create({ baseURL, timeout })

axiosInstance.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
  paramsSerializer: qs.stringify,
}))

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const statusCode = pathOr(null, ['response', 'status'], error)

    if (statusCode === 401 || statusCode === 403) {
      sessionStorage.removeItem('managerPastDues_credores')
      sessionStorage.removeItem('managerPastDues_results')
      sessionStorage.removeItem('managerPastDues_filters')
      sessionStorage.removeItem('managerPastDues_totals')
      window.onerror(`authorization: ${statusCode}`, window.location.href)
      window.location.href = '/#/login'
    }
    return Promise.reject(error.response);
  })



export default axiosInstance
